const list = ['KX80','MB17','OG70','X917','X918','OS58','D774','JM01','JM02','ME50','MY23','MY37','ON02','JM05','OR79','OX76','OX77','PC14',];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

const ex_data = {
    'JM04' : '|CFFffd631双11助力包|r|n|cff99d3ff双11网页活动分享礼包，三位好友助力后可获得，礼包内含有：|r|n|cFFFFFF00两万士兵卷轴(30天)*5|r|n|cFFFFFF00藏龙紫仙玉*100|r|n|cFFFFFF00蓝色幸运符(7天)*3|r',
}

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
    ex_data,
}